// @ts-nocheck
import useEmptyForm from "@store/Framework/Store/Foundation/Components/Form/FormHooks/useEmptyForm";
import useGetFormById from "@store/Framework/Store/Foundation/Components/Form/FormHooks/useGetFormById";
import { FormModel } from "@store/Framework/Store/Foundation/Components/Form/FormTypes";
import destroyForm from "@store/Framework/Store/Foundation/Components/Form/Handlers/DestroyForm";
import setForm from "@store/Framework/Store/Foundation/Components/Form/Handlers/SetForm";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const defaultForm: FormModel = {
    id: "",
    inputs: [],
    hasAlreadyError: false,
};

export default () => {
    const dispatch = useDispatch();
    const [formId] = useState(`form-${uniqueId()}`);
    const emptyForm = useEmptyForm(formId);
    const form = useGetFormById(formId) || defaultForm;

    useEffect(() => {
        dispatch(setForm({ formId }));

        return () => {
            dispatch(destroyForm({ formId }));
        };
    }, []);

    return {
        form,
        emptyForm,
    };
};
